import { render } from "./add-onboarding.vue?vue&type=template&id=665c9bda"
import script from "./add-onboarding.vue?vue&type=script&lang=js"
export * from "./add-onboarding.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/stages_admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__